import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '@modulor/react';
import Image from '../../../../components/Image/Image';
import Skeleton from '../../../../components/Skeleton/Skeleton';
import styles from './SectionCard.module.css';

const skeletonConfig = {
  height: '100%',
  width: '100%',
  count: 1,
  containerClassName: styles.skeleton,
};

const SectionCard = ({ id, title, subtitle, icon, isLoading, className }) => (
  <div className={classNames(styles.component, className)}>
    {isLoading ? (
      <Skeleton config={skeletonConfig} />
    ) : (
      <div className={styles.content}>
        <div className={styles.wrapper}>
          <Image
            src={icon}
            alt={id}
            className={styles.icon}
            fallback={<Icon name="no_icon" className={styles.icon} />}
          />
        </div>
        <div className={styles.description}>
          {title && <span className={styles.title}>{title}</span>}
          {subtitle && <span className={styles.subtitle}>{subtitle} </span>}
        </div>

        <Icon name="chevron_right" className={styles.chevron} />
      </div>
    )}
  </div>
);

SectionCard.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
  subtitle: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
};

SectionCard.defaultProps = {
  icon: '',
  title: '',
  subtitle: '',
  isLoading: false,
};

export default SectionCard;
